import { render, staticRenderFns } from "./VirtualList.vue?vue&type=template&id=4080e91c&"
import script from "./VirtualList.vue?vue&type=script&lang=js&"
export * from "./VirtualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports